import React, { FC } from "react";
import Typography, { TypographyProps } from "@material-ui/core/Typography";

type FormErrorProps = {
  errorMessage: string;
};

const FormError: FC<FormErrorProps & TypographyProps> = ({ errorMessage, ...rest }) => {
  return (
    <Typography
      variant="subtitle2"
      style={{
        fontWeight: 600,
        color: "#DF1E1E",
        fontSize: 12,
      }}
      {...rest}
    >
      {errorMessage}
    </Typography>
  );
};

export default FormError;
